var map = {
	"./asclepio.jpg": 7732,
	"./enfermera.jpg": 713,
	"./enfermera_molesta.jpg": 5697,
	"./entrada_interno.jpg": 7779,
	"./estudioso.jpg": 3469,
	"./gente_enajenada.jpg": 9597,
	"./guardia.jpg": 5129,
	"./interna.jpg": 6421,
	"./interno.jpg": 3011,
	"./kinesiologo.jpg": 2507,
	"./policia.jpg": 4559,
	"./samu.jpg": 4752,
	"./tens_hombre.jpg": 4034,
	"./tens_mujer.jpg": 4866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4424;